"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fiZones = void 0;
var fiZones = exports.fiZones = [{
  id: 'HELSINKI',
  name: 'Helsinki',
  country: 'FI',
  cornerNW: {
    latitude: 60.2978,
    longitude: 24.7842
  },
  cornerSE: {
    latitude: 60.1087,
    longitude: 25.2180
  },
  subZones: [{
    name: 'Helsingfors',
    zipcodes: {
      '00100': {
        label: 'Helsingfors Keskusta'
      },
      '00200': {
        label: 'Helsingfors Kamppi'
      },
      '00500': {
        label: 'Helsingfors Käpylä'
      },
      '00900': {
        label: 'Helsingfors Töölö'
      }
    }
  }]
}];